<template>
  <div class="mb-12 s:mb-14">
    <div class="flex justify-between items-center">
      <b-headline type="h4" typography="h4" class="mb-2 text-left">
        {{ $t("emailPreferences.sections.other.title") }}
      </b-headline>
      <sliding-toggle
        class="m:hidden mb-2"
        @input="onPreferenceChange"
        :value="emailPreferences['other']['all'].subscribed"
        :disabled="emailPreferences['other']['all'].disabled"
      />
    </div>

    <div class="flex justify-between">
      <b-paragraph class="text-left" :no-margin="true">
        {{ $t(`emailPreferences.sections.other.description`) }}
      </b-paragraph>
      <sliding-toggle
        class="xs:hidden m:inline-flex"
        @input="onPreferenceChange"
        :value="emailPreferences['other']['all'].subscribed"
        :disabled="emailPreferences['other']['all'].disabled"
      />
    </div>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import BParagraph from "@/component-library/b-paragraph"
import SlidingToggle from "@/component-library/sliding-toggle"

export default {
  name: "AllPreferences",
  components: {
    BHeadline,
    SlidingToggle,
    BParagraph
  },
  props: {
    emailPreferences: {
      type: Object,
      required: true
    },
    updateCallback: {
      type: Function,
      required: true
    }
  },
  methods: {
    onPreferenceChange(value) {
      const didValueChange = this.emailPreferences["other"]["all"].subscribed !== value

      if (!didValueChange) {
        return
      }

      this.updateCallback({ value })
    }
  }
}
</script>
